import { F0Select } from '@factorialco/f0-react'
import { FinanceEnumsQuoteStatusEnum } from 'generated/resources/graphql'

import { quoteTranslateStatus } from 'modules/finance/components/Quotes/utils'

interface QuoteStatusSelectorProps {
  value: FinanceEnumsQuoteStatusEnum | null | undefined
  onChange: (value: FinanceEnumsQuoteStatusEnum) => void
  label?: string
  error?: string
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const QUOTE_STATUS_OPTIONS: FinanceEnumsQuoteStatusEnum[] = ['accepted', 'draft', 'rejected']

function isValidQuoteStatus(value: string): value is FinanceEnumsQuoteStatusEnum {
  return ['accepted', 'draft', 'rejected'].includes(value)
}

export const QuoteStatusSelector = ({
  value,
  onChange,
  label,
  error,
  disabled,
  size = 'md',
}: QuoteStatusSelectorProps) => {
  const options = QUOTE_STATUS_OPTIONS.map((status) => ({
    label: quoteTranslateStatus(status),
    value: status,
  }))

  return (
    <F0Select
      size={size}
      label={label}
      options={options}
      value={value ?? undefined}
      onChange={(newValue: string) => {
        if (newValue && isValidQuoteStatus(newValue)) {
          onChange(newValue)
        }
      }}
      error={error}
      disabled={disabled}
    />
  )
}
